<!-- Spacer -->
<div
    class="fuse-vertical-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
